import { createContext, useContext } from 'react'

export const UbikEnvContext = createContext<Record<string, string>>({})

export function useEnvContext() {
  return useContext(UbikEnvContext)
}
